import isEmpty from "lodash-es/isEmpty";
import { Button, RemoveIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { Key } from "antd/lib/table/interface";
import { useProcessingConditions } from "../../hooks/designMappings/useProcessingConditions";

type BulkActionRemoveProcessingConditionsProps = {
  selectedRowKeys: Key[];
  setSelectedRowKeys: (keys: Key[]) => void;
};

export const BulkActionRemoveProcessingConditions: React.FC<
  BulkActionRemoveProcessingConditionsProps
> = ({ selectedRowKeys, setSelectedRowKeys }) => {
  const { t } = useTranslation();

  const { removeProcessingConditions } = useProcessingConditions();

  if (isEmpty(selectedRowKeys)) {
    return null;
  }

  return (
    <Button
      key="bulk-remove"
      icon={<RemoveIcon />}
      onClick={() => {
        removeProcessingConditions(selectedRowKeys.map(Number));

        setSelectedRowKeys([]);
      }}
    >
      {t(
        "designMappings.actions.processingConditions.list.actions.remove.button"
      )}
    </Button>
  );
};
